import createRazorBuilder from "./builder.js";
import razorAccordion from "./accordion.js";
import razorCheckbox from "./checkbox.js";
import razorSwitch from "./switch.js";
import razorDialog from "./dialog.js";
import razorDropdown from "./dropdown.js";
import razorFileUpload from "./fileupload.js";
import razorInputPin from "./inputpin.js";
import razorPlace from "./place.js";
import razorTooltip from "./tooltip.js";
import initNavigation from "./navigation.js";
import utils from "./razorUtils.js";
import { sendRequest } from "./request.js";

const builder = createRazorBuilder();
builder
  .add(razorAccordion)
  .add(razorCheckbox)
  .add(razorDialog)
  .add(razorDropdown)
  .add(razorFileUpload)
  .add(razorInputPin)
  .add(razorPlace)
  .add(razorTooltip)
  ;

export function initRazorComponents(win) {
  builder.init(win);
}

/// Exports to window
window.initNavigation = initNavigation;
window.utils = { ...utils, sendRequest };
